import ContainedIcon from './ContainedIcon';

export default ContainedIcon;
